import ShareIcon from "~/assets/icons/ShareIcon";

export default function SetupSectionSharedButtons({ product }) {
    return (
        <>
            <span className="share-button">Share <span><ShareIcon /></span></span>
        </>
    );
}
